<section *ngIf="showContent; else blankView">
  <div class="container flex items-center px-6 py-12 mx-auto" style="min-height:90vh;">
    <div class="flex flex-col items-center max-w-sm mx-auto text-center">
      <p class="p-3 text-sm font-medium rounded-full bg-[#f2f7f9] text-[#2563eb]">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
          class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
        </svg>
      </p>
      <h1 class="mt-3 text-2xl font-medium text-vigp-primary-dark md:text-3xl">Acceso no autorizado</h1>
      <p class="mt-4 text-gray-500 dark:text-gray-400">Tu usuario no tiene los accesos necesarios para este producto
      </p>

      <!-- <div class="flex items-center w-full mt-6 shrink-0 sm:w-auto">
        <button
          class="flex items-center justify-center w-1/2 px-5 py-2 text-sm text-gray-700 transition-colors duration-200 bg-white border rounded-lg gap-x-2 sm:w-auto text-[#2563eb] hover:[#f2f7f9]"
          (click)="redirectToHome()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-5 h-5 rtl:rotate-180">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
          </svg>
          <span>Volver</span>
        </button>
      </div> -->
    </div>
  </div>
</section>

<ng-template #blankView>
  <div style="width: 100%; height: 100%; background-color: transparent;"></div>
</ng-template>
